module.exports = __webpack_public_path__ + "static/media/busd.86ef518529200272d0b7b7e9716fe83d.svg";